module.exports = __webpack_public_path__ + "img/arrow-up.34e01260.svg";